import { getStringSchema, getSelectSchema, getBooleanSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const AsOfAdditCompensation = Yup.array().of(
  Yup.object().shape({
    employeeId: getSelectSchema('Employee'),
    insCompTypeId: getSelectSchema('Addit Compensation'),
  })
);

export const LRPAccountsSchema = Yup.object().shape({
  isSuspended: getBooleanSchema('IsSuspended', false),
  notes: getStringSchema(255, 'Notes').notRequired(),
  asOf: Yup.object().shape(
    {
      servicingAgentId: getSelectSchema('Relationship Owner'),
      insCommScheduleId: getSelectSchema('Commission Schedule'),
      asOfAdditComps: AsOfAdditCompensation,
      sourceEmployeeId: Yup.mixed().when('sourceId', {
        is: (sourceId: any) => sourceId != null,
        then() {
          return getSelectSchema('', 'Required when "Type" is entered');
        },
        otherwise(schema) {
          return schema.notRequired();
        },
      }),
      sourceId: Yup.mixed().when('sourceEmployeeId', {
        is: (sourceEmployeeId: any) => sourceEmployeeId != null,
        then() {
          return getSelectSchema('', 'Required when "Source Employee" is entered');
        },
        otherwise(schema) {
          return schema.notRequired();
        },
      }),
    },
    [['sourceId', 'sourceEmployeeId']]
  ),
});
